<template>
  <v-card
    class="mx-auto overflow-visible"
    width="800px"
    style="margin-top: 0px; margin-bottom: 0px;"
    outlined
  >
    <v-list-item three-line>
      <v-list-item-content class="overflow-visible">
        <v-row class="align-center">
          <v-col cols="12" md="6">
            <v-list-item-title class="display-2 mb-2">Lựa chọn cột hiển thị</v-list-item-title>
          </v-col>
          <v-col cols="12" md="6" class="text-right">
            <v-icon aria-label="Close" @click="closeRowAttribute">mdi-close</v-icon>
          </v-col>
        </v-row>
        <v-row>
          <template v-for="(attribute, index) in cloneRowAttributes">
            <v-col v-if="_.get(attribute,'show', true)" cols="12" md="3" class="pt-0 pb-0" :key="index">
              <v-checkbox class="ma-0" v-model="attribute.value" :label="attribute.title" :readonly="attribute.alwayShow" />
            </v-col>
          </template>
          <template v-for="(objectValue, objectIndex) in objectList">
            <v-col cols="12" md="12" class="pb-0" :key="'object_' +objectIndex">
              <h4>{{getObjectText(objectValue)}}</h4>
            </v-col>
            <template v-for="(attribute, index) in cloneRowAttributes.filter(data => data.object === objectValue)">
              <v-col cols="12" md="3" class="pt-0 pb-0" :key="'coloumn_'+objectIndex+'_'+ index">
                <v-checkbox v-model="attribute.value" :label="attribute.title" />
              </v-col>
            </template>
          </template>
        </v-row>

        <div class="text-center mb-4">
          <v-btn
            class="success mx-0"
            style="margin-right: 10px !important;"
            @click="applyRowAttribute"
          >Áp dụng</v-btn>
          <v-btn class="mx-0" @click="closeRowAttribute">Đóng</v-btn>
        </div>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>
<script>
import {
  contactSettingObjects,
} from '@/helpers/constants';
export default {
  props: {
    filterForm: {
      default: () => ({})
    },
    contactColumns: {
      default: () => ({}),
    },
    rowAttributes:{
      default: () => ([]),
    },
  },
  data() {
    return {
      cloneRowAttributes: []
    };
  },
  computed: {
    objectList() {
      return Object.keys(this.contactColumns);
    }
  },
  created() {
    this.cloneRowAttributes = this.rowAttributes.map(s => ({ ...s }));
  },
  methods: {
    getObjectText(objectValue) {
      const dataObject = contactSettingObjects.find(
        data => data.value === objectValue
      );
      if (!dataObject) {
        return '';
      }
      return dataObject.text;
    },
    applyRowAttribute() {
      const filterFormTemp = this.filterForm;
      filterFormTemp.openRowMenu = false;
      // Luu du lieu vao localStorage
      localStorage.setItem('displayColumnsInOrderPaymentChecklist', JSON.stringify(this.cloneRowAttributes))
      Bus.$emit('contact-change-row-attribute', this.cloneRowAttributes.map(s => ({ ...s })));
    },
    closeRowAttribute() {
      const filterFormTemp = this.filterForm;
      filterFormTemp.openRowMenu = false;
      setTimeout(() => {
        this.cloneRowAttributes = this.rowAttributes.map(s => ({ ...s }));
      }, 100);
    }
  }
};
</script>
